import { defineMessages } from 'react-intl';

export default defineMessages({
  shopdetails_min_delivery_amount: {
    id: 'app.conversion.components.ShopCard.min.delivery.amount',
    defaultMessage: 'Sin mínimo',
  },
  shopdetails_shipping_amount: {
    id: 'app.conversion.components.ShopCard.shipping.amount',
    defaultMessage: 'Envío gratis',
  },
  shopdetails_with_shipping_amount: {
    id: 'app.conversion.components.ShopCard.with.shipping.amount',
    defaultMessage: 'Envío {cartShippingAmount}',
  },
  shopdetails_with_minDeliveryAmmount: {
    id: 'app.conversion.components.ShopCard.with.minimun.deliveryAmount',
    defaultMessage: 'Mínimo {cartMinDeliveryAmount}',
  },
});
